<template>
  <div class="invoice_detail_wrapper">
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">发货单号：{{ arrivalCode }}</span>
                <span :class="`status-${arrivalSts}`">
                {{ convertToName(executionStatusGroup, arrivalSts) }}
                </span>
                <span v-if="info.logisticsFillTypeDesc" :class="`logistics-fill-type`">{{ info.logisticsFillTypeDesc }}</span>
                <el-tag v-if="info.refundId" size="mini" type="warning" style="margin-left: 10px;">换货补发</el-tag>
              </div>
              <div class="customer">{{ unit }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="发货单信息">
            </a-tab-pane>
            <a-tab-pane key="2" tab="日志动态">
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">物流信息</div>
          <!-- <el-descriptions v-if="params.dockingSystem === 'XIAOZI_ERP'" :column="3">
            <el-descriptions-item label="物流公司">{{ info.logistics | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="物流单号">
              <div @click="handleShowExpressDialog" style="color: #237FFA; cursor: default;">
                {{ info.oddNumbers | setEmpty }}{{ info.latestExpress }}
              </div>
            </el-descriptions-item>
          </el-descriptions> -->
          <el-descriptions :column="3">
            <el-descriptions-item label="物流公司">{{ info.logistics.logisticsCompanyName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="物流单号">
              <div @click="handleShowExpressDialog" style="color: #237FFA; cursor: default;">
                {{ info.logistics.code | setEmpty }}{{ info.latestExpress }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12 flex-group">
            <span>发货物资信息</span>
            <span class="right">关联销售单号：<b @click="toOrder" style="color: #1890ff;cursor: default;font-weight: normal;">{{ orderCode }}</b></span>
          </div>
          <TableWithPagination
            v-if="params.dockingSystem === 'XIAOZI_ERP'"
            :columnList="columnList"
            :tableData="goodsSerialList"
            :pagination.sync="goodsSerialPagination"
            @current-change="getGoodsSerialList" />
          <TableWithPagination v-else :columnList="columnList2" :tableData="info.deliveryGoodsList" />
        </div>
        <div class="common">
          <div class="title gap-12">收货人信息</div>
          <!-- <el-descriptions v-if="params.dockingSystem === 'XIAOZI_ERP'" :column="3">
            <el-descriptions-item label="姓名">{{ info.receivingInfo.receivingName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ info.receivingInfo.receivingPhone | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{ info.receivingInfo.detailAddress | setEmpty }}</el-descriptions-item>
          </el-descriptions> -->
          <el-descriptions :column="3">
            <el-descriptions-item label="姓名">{{ info.receiverName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ info.receiverPhone | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{ info.detailAddress | setEmpty }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">附件信息</div>
          <el-form inline>
            <el-form-item label="随货同行单">
              <upload
                :readonly="!checkStateFlag"
                v-model.trim="attchList"
                label="标准协议"
                :limit="10"
                :max-size="10"
                size="small"
                accept="image/jpeg,image/jpg,image/png,image/webp"
              />
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common">
          <TableWithPagination :columnList="logColumns" :tableData="logData" />
        </div>
      </template>
    </div>
    <bottom-panel v-if="checkStateFlag && $withPermission('gongxutong:lvyue:deliver_goods:detail')">
      <el-button type="primary" size="small" @click="subAttchHandle">更新随货同行单</el-button>
    </bottom-panel>

    <ExpressDialog ref="expressDialogRef" :type="params.dockingSystem" />
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { details, updateAccompanyBill, deliveryDetail, queryGoodsSerialPage } from '@/api/invoiceMgr';
import { orderLogs } from '@/api/pickUpOrders';
import { queryKuaiDi100Detail } from '@/api/service';
import { queryLogListById } from '@/api/saleContract';
import ExpressDialog from '@/components/expressDialog.vue';
import { logTypes } from '@/model/logTypes';
import { dateFormat } from '@/utils/dateFormat.js';
import * as Moment from 'dayjs';

const executionStatusGroup = [
  // {
  //   label: '待收货',
  //   value: 1,
  // },
  // {
  //   label: '部分收货',
  //   value: 2,
  // },
  // {
  //   label: '已收货',
  //   value: 3,
  // },
  // {
  //   label: '已取消',
  //   value: 4,
  // },
  {
    label: '已发货',
    value: 1,
  },
  {
    label: '已取消',
    value: 2,
  },
];

export default {
  name: 'invoice_detail',
  mixins: [TablePaginationMixin],
  components: {
    ExpressDialog,
    TableWithPagination,
  },
  props: {
    id: {
      type: String,
    },
    outDeliveryId: {
      type: String,
    },
    arrivalCode: {
      type: String,
    },
    orderId: {
      type: String,
    },
    orderCode: {
      type: String,
    },
    arrivalSts: {
      type: [String, Number],
    },
    unit: {
      type: String,
    },
    outOrderId: {
      type: String,
    },
    dockingSystem: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      params: {},
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      attchList: [],
      executionStatusGroup,
      checkStateFlag: false,
      info: {
        // receivingInfo: {},
        // transPortLocusList: [],
        logistics: {},
      },
      // 发货物资明细走服务端分页：直发单按件一条，大额订单可达数万条，全量返回会打爆后端的堆
      goodsSerialList: [],
      goodsSerialPagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      columnList: [
        {
          label: '商品编码',
          prop: 'goodsCode',
          tooltip: true,
        },
        {
          label: '商品名称',
          prop: 'goodsName',
          tooltip: true,
        },
        {
          label: '规格',
          prop: 'specification',
          tooltip: true,
        },
        {
          label: '型号',
          prop: 'model',
          tooltip: true,
        },
        {
          label: '品牌名称',
          prop: 'brandName',
          tooltip: true,
        },
        {
          label: '生产商',
          prop: 'producer',
          tooltip: true,
        },
        {
          label: '厂家编码',
          prop: 'factoryCode',
          tooltip: true,
        },
        {
          label: '发货数量',
          prop: 'currentArrivalNum',
          tooltip: true,
        },
        {
          label: '生产日期',
          prop: 'productionDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['productionDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '失效日期',
          prop: 'expiryDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['expiryDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '生产批次号',
          prop: 'productionBatchNumber',
          tooltip: true,
        },
        {
          label: '生产序列号',
          prop: 'productionSerialNumber',
          tooltip: true,
        },
        {
          label: '是否医疗件',
          prop: 'isMedichair',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', row.isMedichair === 1 ? '是' : '否');
          },
        },
        {
          label: '注册证号',
          prop: 'regNo',
          tooltip: true,
        },
      ],
      columnList2: [
        {
          label: '商品编码',
          prop: 'skuCode',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', ['XIAOZI_ERP', 'XIAOZI_MIDDLE'].includes(row.dockingSystem) ? row.outSkuCode || '--' : row.skuCode || '--');
          },
        },
        {
          label: '商品名称',
          prop: 'goodsName',
          tooltip: true,
        },
        {
          label: '规格',
          prop: 'specification',
          tooltip: true,
        },
        {
          label: '型号',
          prop: 'model',
          tooltip: true,
        },
        {
          label: '品牌名称',
          prop: 'brandName',
          tooltip: true,
        },
        {
          label: '生产商',
          prop: 'manufacturer',
          tooltip: true,
        },
        {
          label: '厂家编码',
          prop: 'factoryCode',
          tooltip: true,
        },
        {
          label: '发货数量',
          prop: 'quantity',
          tooltip: true,
        },
        {
          label: '生产日期',
          prop: 'productionDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['productionDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '失效日期',
          prop: 'expiryDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['expiryDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '生产批次号',
          prop: 'batchNo',
          tooltip: true,
        },
        {
          label: '生产序列号',
          prop: 'serialNo',
          tooltip: true,
        },
        {
          label: '是否医疗件',
          prop: 'medicalFlag',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', row.medicalFlag ? '是' : '否');
          },
        },
        {
          label: '注册证号',
          prop: 'certificateNumber',
          tooltip: true,
        },
      ],
      logData: [],
      logColumns: [],
      logColumns1: [
        {
          prop: 'logType',
          label: '事项类型',
          width: '300px',
          tooltip: true,
          render: (h, { row }) => {
            let val = '--';

            for (let v of logTypes) {
              if (v.value === row.logType) {
                val = v.label;
                break;
              }
            }

            return h('span', val);
          },
        },
        {
          prop: 'createTime',
          label: '时间',
          width: '300px',
          tooltip: true,
        },
        {
          prop: 'content',
          label: '日志内容',
          tooltip: true,
        },
      ],
      logColumns2: [
        {
          prop: 'eventTypeDesc',
          label: '事项类型',
          width: '300px',
          tooltip: true,
        },
        {
          prop: 'createTime',
          label: '时间',
          width: '300px',
          tooltip: true,
          format: (val) => val && dateFormat(val).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          prop: 'content',
          label: '日志内容',
          tooltip: true,
        },
      ],
    };
  },
  created () {
    this.params = this.$route.query || {};
    // 小紫中台发货单：商品编码后显示我方商品编码（客户商品对照，只读）
    if (this.params.dockingSystem === 'XIAOZI_MIDDLE') {
      const skuIndex = this.columnList2.findIndex(v => v.prop === 'skuCode');
      this.columnList2.splice(skuIndex + 1, 0, {
        label: '我方商品编码',
        prop: 'ourGoodsCode',
        tooltip: true,
        render: (h, { row }) => h('span', row.ourGoodsCode || '--'),
      });
    }
    this.getDetail();
    this.getLog();
  },
  methods: {
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    toOrder () {
      this.$router.push({
        path: '/salesManagement/pickUpOrders/detail',
        query: {
          id: this.orderId,
          orderCode: this.orderCode,
          outOrderId: this.outOrderId,
          dockingSystem: this.params.dockingSystem,
        },
      });
    },
    async handleShowExpressDialog () {
      if (!this.info.logistics.code) return;
      // this.$refs.expressDialogRef.transportCode = this.info.oddNumbers;
      // this.$refs.expressDialogRef.info.logisticsCompany = this.info.logistics;
      // this.$refs.expressDialogRef.info.logisticsCode = this.info.oddNumbers;
      this.$refs.expressDialogRef.transportCode = this.info.logistics.code;
      this.$refs.expressDialogRef.info.logisticsCompany = this.info.logistics.logisticsCompanyName;
      this.$refs.expressDialogRef.info.logisticsCode = this.info.logistics.code;
      if (this.params.dockingSystem !== 'XIAOZI_ERP') {
        const { body } = await queryKuaiDi100Detail({ com: this.info.logistics.logisticsCompanyCode, num: this.info.logistics.code });
        const data = (body?.logisticsTrackList || []).map(i => ({
          context: i.context,
				  recordTime: i.fTime,
        }));
        this.$refs.expressDialogRef.info.recordList = data;
      }
      this.$refs.expressDialogRef.dialogVisible = true;
    },
    async handleCopy () {
      try {
        // const text = this.params.dockingSystem === 'XIAOZI_ERP' ? this.info.oddNumbers : this.info.logistics.code;
        await navigator.clipboard.writeText(this.info.logistics.code);
        this.$message({
          type: 'success',
          message: '文本已成功拷贝到剪贴板',
          duration: 1000,
        });
      } catch (err) {
        console.error('无法拷贝文本: ', err);
      }
    },
    subAttchHandle () {
      // if (this.info.sellerNoticeDetailsRepDtoBuilderList.length && !!this.info.sellerNoticeDetailsRepDtoBuilderList.find(i => i.isMedichair === 1) && !this.attchList.length) {
      //   return this.$message.error('发货单中含有医疗件，请上传随货同行单');
      // }
      const param = {
        accompanyBillList: this.attchList.map((i) => ({ annexName: i.attachName, annexUrl: i.url })),
        id: this.id,
        syncToXzErp: true,
      };
      updateAccompanyBill(param).then(() => {
        this.$message.success('修改附件成功');
        this.$router.go(-1);
      });
    },
    formateDate (date, format) {
      if (!date) {
        return '--';
      } else {
        return Moment(date).format(format);
      }
    },
    getLog () {
      if (this.params.dockingSystem === 'XIAOZI_ERP') {
        this.logColumns = this.logColumns1;
        queryLogListById({
          id: this.outDeliveryId,
        }).then(({ body }) => {
          this.logData = body || [];
        });
      } else {
        this.logColumns = this.logColumns2;
        orderLogs({
          businessId: this.id,
          businessType: 'SALE_DELIVERY',
          module: 'SALE',
          orderBy: [{
            orderByType: 'DESC',
            orderByProperty: 'lastUpdateTime',
          }],
          pageFlag: false,
        }).then(({ body }) => {
          this.logData = body?.list || [];
        });
      }
    },
    getDetail () {
      // details({ id: this.id }).then(({ body }) => {
      //   let { receivingInfo, accompanyBilList, checkState } = body;
      //   receivingInfo.detailAddress
      //       = `${receivingInfo.receivingProvinceName || ''}${receivingInfo.receivingCityName || ''}${
      //       receivingInfo.receivingAreaName || ''
      //     }${receivingInfo.receivingAddrs || ''}` || '--';

      //   body.transPortLocusList = body.transPortLocusList || [];
      //   this.attchList = accompanyBilList.map((i) => ({
      //     id: i.id,
      //     attachName: i.annexName,
      //     url: i.annexUrl,
      //   }));
      //   this.checkStateFlag = checkState === 'NO';
      //   this.info = body;
      //   this.info.latestExpress = body?.transPortLocusList?.length && body.transPortLocusList[0]?.kuaiDiRecordRes?.length ? `【${body.transPortLocusList[0].kuaiDiRecordRes[0].status} | ${body.transPortLocusList[0].kuaiDiRecordRes[0].context}】` : '';
      // });
      deliveryDetail({ id: this.id, findAccompanyBillFlag: true, findDeliveryGoodsFlag: true, findLogisticsFlag: true, findDeliveryGoodsSerialFlag: true, findOrderFlag: true }).then(({ body }) => {
        let { accompanyBillList, orderReceiveStatus } = body;
        body.detailAddress = `${body.receiverProvinceName || ''}${body.receiverCityName || ''}${body.receiverAreaName || ''}${body.receiverDetailAddress || ''}` || '--';
        this.attchList = accompanyBillList.map((i) => ({
          id: i.id,
          attachName: i.annexName,
          url: i.url,
        }));
        this.checkStateFlag = orderReceiveStatus !== 3;
        // 一个商品可能分多个批次发货，多批次时按批次拆行，发货数量取各批次的
        body.deliveryGoodsList = (body.deliveryGoodsList || []).reduce((rows, i) => {
          const serialList = i.deliveryGoodsSerialList?.length ? i.deliveryGoodsSerialList : [{}];
          serialList.forEach(deliveryGoodsSerial => {
            rows.push({
              ...i,
              dockingSystem: body.dockingSystem,
              quantity: serialList.length > 1 ? deliveryGoodsSerial.quantity : i.quantity,
              productionDate: deliveryGoodsSerial.productionDate,
              expiryDate: deliveryGoodsSerial.expiryDate,
              batchNo: deliveryGoodsSerial.batchNo,
              serialNo: deliveryGoodsSerial.serialNo,
            });
          });
          return rows;
        }, []);
        this.info = body;
        this.info.logistics = body?.logisticsList?.length ? body.logisticsList[0] : {};
        this.info.latestExpress = null;
        if (this.params.dockingSystem === 'XIAOZI_ERP') {
          // 商品明细已改用 queryGoodsSerialPage 分页获取，这里跳过，避免接口全量返回数万条
          details({ id: this.outDeliveryId, skipGoodsSerialFlag: true }).then(({ body }) => {
            this.info.logistics = {
              code: body.oddNumbers,
              logisticsCompanyName: body.logistics,
              logisticsCompanyCode: '',
            };
            this.info.latestExpress = body?.transPortLocusList?.length && body.transPortLocusList[0]?.kuaiDiRecordRes?.length ? `【${body.transPortLocusList[0].kuaiDiRecordRes[0].status} | ${body.transPortLocusList[0].kuaiDiRecordRes[0].context}】` : '';
            this.checkStateFlag = body.checkState === 'NO';
          });
          this.getGoodsSerialList();
        }
      });
    },
    // 发货物资明细分页查询
    getGoodsSerialList () {
      queryGoodsSerialPage({
        id: this.outDeliveryId,
        pageNum: this.goodsSerialPagination.currentPage,
        pageSize: this.goodsSerialPagination.pageSize,
      }).then(({ body }) => {
        this.goodsSerialList = body.list || [];
        this.goodsSerialPagination.total = body.total || 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.invoice_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }
    .flex-group {
      display: flex;
      justify-content: space-between;
      .right {
        font-weight: normal;
        color: #606266;
      }
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              // .status-1,
              // .status-2 {
              //   @include tag_round();
              //   background-color: #E2F3FE;
              //   color: #237FFA;
              // }

              .status-2 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-1 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }

              .logistics-fill-type {
                margin-left: 10px;
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }
}
</style>
